export default "__VITE_ASSET__C_FZRp63__"